import {
  ReceiptLongIcon,
  TrendingUpIcon,
  AccountBalanceWalletIcon,
  RemoveCircleOutlineIcon,
  LocationOnIcon,
  GroupsIcon,
} from '@billda/design-system';
import { MetricCard } from '../atoms/MetricCard';
import { useGetDashboardMetrics } from '../../hooks/useGetDashboardMetrics';
import { formatCurrency } from '../../../../shared/utils/currency';

const metrics = [
  {
    key: 'activePots',
    label: 'Active Pots',
    icon: <ReceiptLongIcon aria-hidden="true" />,
    iconClassName: 'bg-surface-info-subtle text-content-info',
    format: (v: number) => v.toLocaleString('en-GB'),
  },
  {
    key: 'grossValue',
    label: 'Gross Value',
    icon: <TrendingUpIcon aria-hidden="true" />,
    iconClassName: 'bg-surface-success-subtle text-content-success',
    format: formatCurrency,
  },
  {
    key: 'netValue',
    label: 'Net Value',
    icon: <AccountBalanceWalletIcon aria-hidden="true" />,
    iconClassName: 'bg-surface-primary-soft text-content-accent',
    format: formatCurrency,
  },
  {
    key: 'deductions',
    label: 'Deductions',
    icon: <RemoveCircleOutlineIcon aria-hidden="true" />,
    iconClassName: 'bg-surface-error-soft text-content-error',
    format: formatCurrency,
  },
  {
    key: 'activeSites',
    label: 'Active Sites',
    icon: <LocationOnIcon aria-hidden="true" />,
    iconClassName: 'bg-surface-warning-subtle text-content-warning',
    format: (v: number) => v.toLocaleString('en-GB'),
  },
  {
    key: 'workers',
    label: 'Workers',
    icon: <GroupsIcon aria-hidden="true" />,
    iconClassName: 'bg-surface-info-subtle text-content-info',
    format: (v: number) => v.toLocaleString('en-GB'),
  },
] as const;

export function MetricsGrid() {
  const { data, isLoading } = useGetDashboardMetrics();

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-6">
      {metrics.map(metric => (
        <MetricCard
          key={metric.key}
          label={metric.label}
          value={
            data
              ? metric.format(data[metric.key as keyof typeof data] as number)
              : ''
          }
          icon={metric.icon}
          iconClassName={metric.iconClassName}
          isLoading={isLoading}
          testId={`metric-${metric.key}`}
        />
      ))}
    </div>
  );
}
